import { useState } from "react";
import { Dialog, DialogContent } from "../components/ui/dialog";
import { GALLERY } from "../data/cafeData";

const FILTERS = [
  { id: "all", label: "All" },
  { id: "brews", label: "Brews" },
  { id: "bakery", label: "Bakery" },
  { id: "space", label: "The Space" },
];

export const Gallery = () => {
  const [filter, setFilter] = useState("all");
  const [selected, setSelected] = useState(null);

  const items = GALLERY.filter((g) => filter === "all" || g.group === filter);

  return (
    <section id="gallery" data-testid="gallery-section" className="bg-[#FDFBF7] py-24 md:py-32">
      <div className="mx-auto max-w-6xl px-5 md:px-8">
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <div>
            <p className="font-accent text-xs font-semibold uppercase tracking-[0.25em] text-[#C86D51]">
              The Vibe
            </p>
            <h2 className="mt-4 font-serif text-2xl font-bold tracking-tight text-[#2C1D11] sm:text-3xl lg:text-4xl">
              Moments from the counter
            </h2>
          </div>
          <div className="flex flex-wrap gap-2" data-testid="gallery-filters">
            {FILTERS.map((f) => (
              <button
                key={f.id}
                data-testid={`gallery-filter-${f.id}`}
                onClick={() => setFilter(f.id)}
                className={`rounded-full px-4 py-2 font-accent text-xs font-semibold uppercase tracking-wider transition-colors duration-200 ${
                  filter === f.id
                    ? "bg-[#2C1D11] text-[#FDFBF7]"
                    : "bg-[#F5EFE6] text-[#6E5E53] hover:bg-[#EBE2D4] hover:text-[#2C1D11]"
                }`}
              >
                {f.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-12 grid grid-cols-2 gap-4 md:grid-cols-3 md:gap-5">
          {items.map((item, i) => (
            <button
              key={item.title}
              data-testid={`gallery-item-${i}`}
              onClick={() => setSelected(item)}
              className={`group relative overflow-hidden rounded-3xl text-left ${
                i % 5 === 0 ? "row-span-2 aspect-[3/4] md:aspect-auto" : "aspect-square"
              }`}
            >
              <img
                src={item.url}
                alt={item.title}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#21150C]/80 via-transparent to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
              <div className="absolute bottom-0 left-0 right-0 translate-y-3 p-5 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                <p className="font-accent text-[10px] font-semibold uppercase tracking-[0.2em] text-[#D49B4B]">
                  {item.category}
                </p>
                <p className="mt-1 font-serif text-lg font-semibold text-[#FDFBF7]">{item.title}</p>
              </div>
            </button>
          ))}
        </div>
      </div>

      <Dialog open={!!selected} onOpenChange={() => setSelected(null)}>
        <DialogContent
          data-testid="gallery-lightbox"
          className="max-w-3xl overflow-hidden border-none bg-[#21150C] p-0"
        >
          {selected && (
            <div>
              <img src={selected.url} alt={selected.title} className="max-h-[70vh] w-full object-cover" />
              <div className="p-5">
                <p className="font-accent text-[10px] font-semibold uppercase tracking-[0.2em] text-[#D49B4B]">
                  {selected.category}
                </p>
                <p className="mt-1 font-serif text-xl font-semibold text-[#FDFBF7]">{selected.title}</p>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
};
